<template>
    <div class="mt--30 mb--15">
        <template v-if="groupSelection === 'none'">
            <div v-for="item in tasks" :key="item._id" class="client__notes__item task__item" @click.prevent="setCurrentTask(item)">
                <div class="w-100 flex align-items-center justify-content-between" :class="{ 'disabled': taskIdToModify === item._id && markCompletedLoading }">
                    <div class="cursor-pointer flex-1">
                        <div class="form-check mb--0">
                            <input id="flexCheckDefault" class="form-check-input" type="checkbox" @change.stop="e => markTaskAsCompleted(e, item)">
                            <label class="form-check-label task__item__label text--sm cursor-pointer" for="flexCheckDefault">
                                {{ item.name }}
                                <div class="flex align-items-center mt--5">
                                    <div v-if="item.deadline" class="flex align-items-center">
                                        <span class="mr--5">
                                            <icon-svg name="calendar" fill="#BF2C6F" width="12px" height="12px" />
                                        </span>
                                        <span class="task__item__deadline">{{ $format_date(item.deadline) }}</span>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <ul v-for="task in tasks" :key="task._id">
                <div class="revenue__date__header">
                    {{ task._id }}
                </div>

                <template v-if="task.tasks">
                    <div v-for="item in task.tasks" :key="item._id" class="client__notes__item task__item">
                        <div class="w-100 flex align-items-center justify-content-between" :class="{ 'disabled': taskIdToModify === item._id && markCompletedLoading }">
                            <div class="cursor-pointer flex-1">
                                <div class="form-check mb--0">
                                    <input id="flexCheckDefault" class="form-check-input" type="checkbox" @change.stop="e => markTaskAsCompleted(e, item)">
                                    <label class="form-check-label task__item__label text--sm cursor-pointer" for="flexCheckDefault" @click.prevent="setCurrentTask(item)">
                                        {{ item.name }}
                                        <div class="flex align-items-center mt--5">
                                            <div v-if="item.project" class="text-gray-200 text--xs task__project__title ml--5">
                                                # {{ item.project.title }}
                                            </div>
                                            <span v-if="item.project && item.deadline" class="ml--5 mr--5 text-gray-200">|</span>
                                            <div v-if="item.deadline" class="flex align-items-center">
                                                <span class="mr--5">
                                                    <icon-svg name="calendar" fill="#BF2C6F" width="12px" height="12px" />
                                                </span>
                                                <span class="task__item__deadline">{{ $format_date(item.deadline) }}</span>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </ul>
        </template>
    </div>
</template>

<script>
import {
    IconSvg,
} from "@/components/ui/index";
import { tasksGroup } from "@/utils/dummy";

export default {
    name: "TaskList",

    components: {
        IconSvg,
    },

    props: {
        groupSelection: {
            type: String,
            default: "none",
        },

        tasks: {
            type: Array,
            default: () => [],
        },

        pageData: {
            type: Object,
            default: () => {},
        },

        currentTaskId: {
            type: String,
            default: "",
        },
    },

    emits: ["set-current-task"],

    data() {
        return {
            markCompletedLoading: false,
            taskIdToModify: "",
            tasksGroup,
        };
    },

    computed: {
        showActionBtns() {
            if (this.pageData?.total) {
                return true;
            }

            if (this.isSearched) {
                return true;
            }
            
            return false;
        },

        isSearched() {
            return Object.keys(this.$route.query).length > 0;
        },
    },

    methods: {
        setCurrentTask(task) {                        
            this.$emit("set-current-task", task);
        },

        async markTaskAsCompleted(e, task) {
            try {        
                this.markCompletedLoading = true;        
                this.taskIdToModify = task._id;
                
                const val = e?.target?.checked;
                const payload = {
                    _id: task._id, 
                    isCompleted: val, 
                    projectId: task?.project?._id, 
                    name: task.name,
                    description: task.description,
                };

                await this.$store.dispatch("task/editTask", { 
                    payload,
                    fullData: {
                        ...payload, 
                        ...task,
                    },
                    groupBy: this.groupSelection,
                });
                
                this.$toast.success("Task completed");
                this.$emit("reset-current-task");
            } catch (err) {
                const errMsg = err?.response?.data?.message || err?.message;
                this.$toast.error(errMsg);
            } finally {
                this.markCompletedLoading = false;
                this.taskIdToModify = "";
            }
        },
    },
};
</script>